import React from 'react';
export function SectionDivider() {
  return <div className="flex items-center justify-center py-12" data-id="element-271">
      <div className="flex items-center w-full max-w-md" data-id="element-272">
        <div className="flex-1 h-px bg-gold" data-id="element-273"></div>
        <div className="mx-4 w-3 h-3 bg-gold transform rotate-45" data-id="element-274"></div>
        <div className="flex-1 h-px bg-gold" data-id="element-275"></div>
      </div>
    </div>;
}